import { render, staticRenderFns } from "./HomeClassic.vue?vue&type=template&id=f119fcd6&scoped=true"
import script from "./HomeClassic.vue?vue&type=script&lang=js"
export * from "./HomeClassic.vue?vue&type=script&lang=js"
import style0 from "./HomeClassic.vue?vue&type=style&index=0&id=f119fcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f119fcd6",
  null
  
)

export default component.exports